<!-- Display the dynamically created component -->
<ng-template #dynamicComponentView></ng-template>
